export default __webpack_public_path__ + "static/media/flag-micronesia-(federated-states-of).b5f850e6.svg";